export const navCopy = {
  skip_to_content: "跳转到内容",
  nav_documentation: "文档",
  nav_documentation_short: "文档",
  nav_download: "下载",
  nav_community: "联系我们",
  nav_tools: "工具链",
  nav_search_placeholder: "搜索文档",
  nav_search_aria: "搜索 TypeScript 网站",
  nav_beta: "搜索 TypeScript 网站",
  nav_beta_notification:
    "注: 这是一个 beta 测试页面，不要依赖这些 Url，并且 <a>在 microsoft/TypeScript-Website 提出问题</a>",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_playground: "游乐场",
  nav_playground_short: "尝试",
  nav_handbook: "手册",
  nav_this_page_in_your_lang: "当前页面有适用于您语言的翻译版本",
  nav_this_page_in_your_lang_open: "打开",
  nav_this_page_in_your_lang_no_more: "不再询问",
  nav_version_stable_prefix: "已经发布",
  nav_version_between: ", ",
  nav_version_beta_prefix: "目前在 beta 测试中。",
  nav_version_rc_prefix: "可以尝试预发布版本。",
}
